import { Component, EventEmitter, Input, output, ChangeDetectionStrategy } from '@angular/core';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'modal-header',
  imports: [
    MatIconModule,
    MatDividerModule
  ],
  templateUrl: './modal-header.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './modal-header.component.scss'
})
export class ModalHeaderComponent {
  @Input() title: string = "";

  closeModalFromHeader = output<boolean>();

  closeModal() {
    this.closeModalFromHeader.emit(true);
  }
}
